/* lua.js generated code undefined */
 // 30日活跃标签配置
let config = table(
    [1, 0, table(
        [1, "type", "login"],
        [1, "min", 0],
        [1, "max", 0]
    )],
    [1, 1, table(
        [1, "type", "login"],
        [1, "min", 1],
        [1, "max", 1]
    )],
    [1, 2, table(
        [1, "type", "login"],
        [1, "min", 2],
        [1, "max", 2]
    )],
    [1, 3, table(
        [1, "type", "login"],
        [1, "min", 3],
        [1, "max", 3]
    )],
    [1, 4, table(
        [1, "type", "login"],
        [1, "min", 4],
        [1, "max", 4]
    )],
    [1, 5, table(
        [1, "type", "login"],
        [1, "min", 5],
        [1, "max", 5]
    )],
    [1, 6, table(
        [1, "type", "login"],
        [1, "min", 6],
        [1, "max", 6]
    )],
    [1, 7, table(
        [1, "type", "login"],
        [1, "min", 7],
        [1, "max", 7]
    )],
    [1, 8, table(
        [1, "type", "login"],
        [1, "min", 8],
        [1, "max", 8]
    )],
    [1, 9, table(
        [1, "type", "login"],
        [1, "min", 9],
        [1, "max", 9]
    )],
    [1, 10, table(
        [1, "type", "login"],
        [1, "min", 10],
        [1, "max", 10]
    )],
    [1, 11, table(
        [1, "type", "login"],
        [1, "min", 11],
        [1, "max", 11]
    )],
    [1, 12, table(
        [1, "type", "login"],
        [1, "min", 12],
        [1, "max", 12]
    )],
    [1, 13, table(
        [1, "type", "login"],
        [1, "min", 13],
        [1, "max", 13]
    )],
    [1, 14, table(
        [1, "type", "login"],
        [1, "min", 14],
        [1, "max", 14]
    )],
    [1, 15, table(
        [1, "type", "login"],
        [1, "min", 15],
        [1, "max", 15]
    )],
    [1, 16, table(
        [1, "type", "login"],
        [1, "min", 16],
        [1, "max", 16]
    )],
    [1, 17, table(
        [1, "type", "login"],
        [1, "min", 17],
        [1, "max", 17]
    )],
    [1, 18, table(
        [1, "type", "login"],
        [1, "min", 18],
        [1, "max", 18]
    )],
    [1, 19, table(
        [1, "type", "login"],
        [1, "min", 19],
        [1, "max", 19]
    )],
    [1, 20, table(
        [1, "type", "login"],
        [1, "min", 20],
        [1, "max", 20]
    )],
    [1, 21, table(
        [1, "type", "login"],
        [1, "min", 21],
        [1, "max", 21]
    )],
    [1, 22, table(
        [1, "type", "login"],
        [1, "min", 22],
        [1, "max", 22]
    )],
    [1, 23, table(
        [1, "type", "login"],
        [1, "min", 23],
        [1, "max", 23]
    )],
    [1, 24, table(
        [1, "type", "login"],
        [1, "min", 24],
        [1, "max", 24]
    )],
    [1, 25, table(
        [1, "type", "login"],
        [1, "min", 25],
        [1, "max", 25]
    )],
    [1, 26, table(
        [1, "type", "login"],
        [1, "min", 26],
        [1, "max", 26]
    )],
    [1, 27, table(
        [1, "type", "login"],
        [1, "min", 27],
        [1, "max", 27]
    )],
    [1, 28, table(
        [1, "type", "login"],
        [1, "min", 28],
        [1, "max", 28]
    )],
    [1, 29, table(
        [1, "type", "login"],
        [1, "min", 29],
        [1, "max", 29]
    )],
    [1, 30, table(
        [1, "type", "login"],
        [1, "min", 30],
        [1, "max", 30]
    )]
)
module.exports = config
